import {
  IGetVerificationCodePayload,
  IGetVerificationCodeResponse,
  IVerifyDomainPayload,
  IVerifyDomainResponse,
  IUpdateProfilePayload,
} from 'src/config/types';
import URIs from 'src/config/urls';
import requests from '.';

const { SIGNUP, PROFILE, TEAM_BUILDER, META_DATA, TIMELINE } = URIs;

const {
  ROUTE_PATH: SIGNUP_BASE_PATH,
  END_POINTS: { GET_VERIFICATION_CODE, VERIFY_DOMAIN },
} = SIGNUP;
const {
  ROUTE_PATH: PROFILE_BASE_PATH,
  END_POINTS: { UPDATE_PROFILE, GET_PROFILE },
} = PROFILE;
const {
  ROUTE_PATH: TEAM_BUILDER_BASE_PATH,
  END_POINTS: {
    GET_MEMBERS: TEAM_BUILDER_GET_MEMBERS,
    GET_PROJECTS: TEAM_BUILDER_GET_PROJECTS,
    UPDATE_PROJECTS: TEAM_BUILDER_UPDATE_PROJECTS,
    GET_STAFFING_REQUIREMENTS: TEAM_BUILDER_PROJECT_STAFFING_REQUIREMENTS,
    UPDATE_STAFFING_REQUIREMENTS:
      TEAM_BUILDER_UPDATE_PROJECT_STAFFING_REQUIREMENTS,
  },
} = TEAM_BUILDER;
const {
  ROUTE_PATH: TIMELINE_BASE_PATH,
  END_POINTS: { GET_TIMELINE },
} = TIMELINE ?? {};
const {
  END_POINTS: { GET_ALL_FILTERS },
} = META_DATA;

const http = {
  // Signup
  getVerificationCode: async (
    payload: IGetVerificationCodePayload,
    baseURL: any
  ): Promise<IGetVerificationCodeResponse> => {
    return requests(baseURL).post(
      `${SIGNUP_BASE_PATH}${GET_VERIFICATION_CODE}`,
      payload
    );
  },
  verifyDomain: async (
    payload: IVerifyDomainPayload,
    baseURL: any
  ): Promise<IVerifyDomainResponse> => {
    return requests(baseURL).post(
      `${SIGNUP_BASE_PATH}${VERIFY_DOMAIN}`,
      payload
    );
  },
  updateProfile: async (payload: IUpdateProfilePayload, baseURL: any) => {
    return requests(baseURL).put(
      `${PROFILE_BASE_PATH}${UPDATE_PROFILE}`,
      payload
    );
  },
  getProfile: async (baseURL: any) => {
    return requests(baseURL).get(`${PROFILE_BASE_PATH}${GET_PROFILE}`);
  },
  getAllProjects: async (baseURL: any) => {
    return requests(baseURL).get(
      `${TEAM_BUILDER_BASE_PATH}${TEAM_BUILDER_GET_PROJECTS}`
    );
  },
  getAllMembers: async (baseURL: any) => {
    return requests(baseURL).get(
      `${TEAM_BUILDER_BASE_PATH}${TEAM_BUILDER_GET_MEMBERS}`
    );
  },
  updateProjects: async (baseURL: any, data: any) => {
    return requests(baseURL).post(
      `${TEAM_BUILDER_BASE_PATH}${TEAM_BUILDER_UPDATE_PROJECTS}`,
      data
    );
  },
  getProjectStaffingRequirements: async (baseURL: any, id: string) => {
    return requests(baseURL).get(
      `${TEAM_BUILDER_PROJECT_STAFFING_REQUIREMENTS}/${id}`
    );
  },
  getAllFilters: async (baseURL: any) => {
    return requests(baseURL).get(GET_ALL_FILTERS);
  },
  updateProjectStaffingRequirements: async (
    baseURL: any,
    id: string,
    payload: any
  ) => {
    return requests(baseURL).post(
      `${TEAM_BUILDER_UPDATE_PROJECT_STAFFING_REQUIREMENTS}/${id}`,
      payload
    );
  },

  //? TIMELINE
  getTimeline: async (baseURL: any, params?: string) => {
    return requests(baseURL).get(
      `${TIMELINE_BASE_PATH}${GET_TIMELINE}${params}`
    );
  },
};

export default http;
